import dayjs from "dayjs";
import React, { Fragment, useEffect, useState } from "react";
import {
  BsFillArrowLeftCircleFill,
  BsFillArrowRightCircleFill
} from "react-icons/bs";
import DateField from "../components/DateField";
import {
  formatearHoraHHMM,
  restarUnDia,
  sumarUnDia
} from "../utils/dates";
import { useRequestHandler } from "../utils/useRequestHandler";
import Servicios from "../services";

const Home = () => {
  const [fecha, setFecha] = useState(new Date());
  const [programacionTablados, setProgramacionTablados] = useState([]);
  const [desde, setDesde] = useState(new Date());
  const [hasta, setHasta] = useState(new Date());
  const [retornoCarga, setRetornoCarga] = useState();
  const fetchProgramacion = () => {
    sendRequest(
      Servicios.ObtenerProgramacionTablados,
      [new Date(fecha)],
      data => {
        setProgramacionTablados(data?.data);
      }
    );
  };
  const sendRequest = useRequestHandler();
  useEffect(() => {
    fetchProgramacion();
  }, [fecha]);

  return (
    <Fragment>
      <>
        <div className="flex flex-wrap items-center gap-3 programacion-tablado-card p-4">
          <div className="dark:text-gray-200">Desde:</div>
          <div>
            <DateField
              value={desde}
              onChange={setDesde}
              ariaLabel="Desde"
            />
          </div>
          <div className="dark:text-gray-200">Hasta:</div>
          <div>
            <DateField
              value={hasta}
              onChange={setHasta}
              ariaLabel="Hasta"
            />
          </div>
          <div>
            <button
              className="btn-primary"
              onClick={() => {
                sendRequest(
                  Servicios.CargaAutomaticaTabladoProgramacion,
                  [new Date(desde), new Date(hasta)],
                  data => {
                    setRetornoCarga(data?.data);
                    fetchProgramacion();
                  }
                );
              }}
            >
              CARGA AUTOMÁTICA
            </button>
          </div>

          {(process.env.REACT_APP_ENVIRONMENT == "LOCAL" ||
            process.env.REACT_APP_ENVIRONMENT == "DEV") && (
            <div>
              <button
                className="btn-danger"
                onClick={() => {
                  if (window.confirm("OJO CON ESTO!!!!")) {
                    sendRequest(
                      Servicios.GenerarProgramacionRandom,
                      [new Date(desde), new Date(hasta)],
                      () => {
                        fetchProgramacion();
                      }
                    );
                  }
                }}
              >
                CARGA ALEATORIA
              </button>
            </div>
          )}
          {retornoCarga && (
            <div className="info-card text-start w-full mt-4">
              <h2 className="text-lg font-bold dark:text-gray-100">Información de Carga</h2>
              <br></br>
              <ul className="list-disc ps-5 dark:text-gray-200">
                <li>
                  <span className="font-bold dark:text-gray-100">
                    Cantidad de Horarios Insertados:
                  </span>{" "}
                  {retornoCarga.cantidadHorariosInsertados}
                </li>
                <li>
                  <span className="font-bold dark:text-gray-100">
                    Cantidad de Horarios Actualizados:
                  </span>{" "}
                  {retornoCarga.cantidadHorariosActualizados}
                </li>
                <li>
                  <span className="font-bold dark:text-gray-100">
                    Cantidad de Contratos Insertados:
                  </span>{" "}
                  {retornoCarga.cantidadContratosInsertados}
                </li>
                <li>
                  <span className="font-bold dark:text-gray-100">
                    Cantidad de Contratos Quitados (cancelados o movidos):
                  </span>{" "}
                  {retornoCarga.cantidadContratosQuitados ?? 0}
                </li>
                <li>
                  <span className="font-bold dark:text-gray-100">
                    Cantidad de Tablados Faltantes:
                  </span>{" "}
                  {retornoCarga.cantidadTabladosFaltantes}
                </li>
                <li>
                  <span className="font-bold dark:text-gray-100">
                    Cantidad de Conjuntos Faltantes:
                  </span>{" "}
                  {retornoCarga.cantidadConjuntosFaltantes}
                </li>
                <li>
                  <span className="font-bold dark:text-gray-100">
                    Cantidad de Excepciones Capturadas:
                  </span>{" "}
                  {retornoCarga.cantidadExcepcionesCapturadas}
                </li>
                <br></br>
                <li>
                  <span className="font-bold dark:text-gray-100">Novedades:</span>
                  <ul className="list-disc ps-5 mt-1">
                    {retornoCarga.novedades.map((novedad, index) => (
                      <li key={index}>{novedad}</li>
                    ))}
                  </ul>
                </li>
              </ul>
            </div>
          )}
        </div>

        <div className="flex flex-wrap items-center justify-between my-4 gap-4">
          <div>
            <h4 className="page-title dark:text-gray-100">Programación de tablados </h4>
          </div>
          <div>
            <div className="flex items-center gap-2">
              <div>
                <BsFillArrowLeftCircleFill
                  className="m-2 cursor-pointer dark:text-gray-200"
                  size={26}
                  onClick={() => setFecha(restarUnDia(fecha))}
                />
              </div>
              <div>
                <DateField
                  value={fecha}
                  onChange={setFecha}
                  ariaLabel="Fecha de programación"
                />
              </div>
              <div>
                <BsFillArrowRightCircleFill
                  className="m-2 cursor-pointer dark:text-gray-200"
                  size={26}
                  onClick={() => setFecha(sumarUnDia(fecha))}
                />
              </div>
            </div>
          </div>
        </div>
        <hr className="dark:border-gray-600"></hr>
        <div className="flex flex-wrap gap-4 p-4">
          {programacionTablados?.map(x => (
            <div className="programacion-tablado-card">
              <h6 className="font-semibold dark:text-gray-100">{x.nombre}</h6>
              <hr className="dark:border-gray-600"></hr>
              {x?.conjuntos?.map(y => (
                <div className="item">
                  <div className="flex items-center gap-2 px-1">
                    <div className="dark:text-gray-200">{y.orden}</div>
                    <div className="flex-1 text-start dark:text-gray-200">{y?.nombre}</div>
                    <div className="dark:text-gray-200">
                      {formatearHoraHHMM(y.fechaHora)}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ))}
        </div>
      </>
    </Fragment>
  );
};

export default Home;
